(function () {
  if (window.__NB_UPGRADE_WIDGET_LOGIC_INITIALIZED__) return;
  window.__NB_UPGRADE_WIDGET_LOGIC_INITIALIZED__ = true;

  console.warn('[NB Upgrade Widget] Script loaded from asset');

  /*
    CONFIG — only update this section for future offer changes.
    (Keep it in sync with snippets/cart-upgrade-widget-gate.liquid.)

    Each rule: if a cart item has `fromSellingPlanId` AND (if set) its SKU equals `fromSku`,
    the upgrade replaces it with `toVariantId` on `toSellingPlanId`.
    Upgrade quantity = cart item quantity × `qtyMultiplier`.
    `fromSku: null` means any SKU on that selling plan.
    `product` ties the rule to its widget: 'gummies' or 'powder'.
  */
  const NB_UPGRADE_RULES = [
    // GUMMIES — One Kid (1 → 1 three-pack)
    { product: 'gummies', fromSellingPlanId: 2701328466, fromSku: 'NBGum-60-J2-SUB',      toVariantId: 42837961703506, toSellingPlanId: 2701361234, qtyMultiplier: 1 },
    // GUMMIES — Two Kids (1 → 2 three-packs)
    { product: 'gummies', fromSellingPlanId: 2701328466, fromSku: 'NBGum-60-J2-SUB (x2)', toVariantId: 42837961703506, toSellingPlanId: 2701361234, qtyMultiplier: 2 },

    // FLAVORLESS POWDER — One Kid (1 → 1 three-pack)
    { product: 'powder',  fromSellingPlanId: 2584805458, fromSku: 'NB-FP-01-SUB',         toVariantId: 42757669191762, toSellingPlanId: 2676785234, qtyMultiplier: 1 },
    // FLAVORLESS POWDER — Two Kids (1 → 2 three-packs = 6 tubs)
    { product: 'powder',  fromSellingPlanId: 2584805458, fromSku: 'NB-FP-01-SUB (x2)',    toVariantId: 42757669191762, toSellingPlanId: 2676785234, qtyMultiplier: 2 },

    // Legacy gummies offer (remove these two lines once old pages are retired)
    { product: 'gummies', fromSellingPlanId: 2356379730, fromSku: null, toVariantId: 42452577747026, toSellingPlanId: 2455208018, qtyMultiplier: 1 },
    { product: 'gummies', fromSellingPlanId: 2583330898, fromSku: null, toVariantId: 42452577747026, toSellingPlanId: 2455208018, qtyMultiplier: 1 }
  ];

  const NB_MIN_QTY = 1; // no upper limit
  const NB_LINE_SELECTOR = '[data-nb-upgrade-widget-line]';
  const NB_CART_SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  let nbUpgradeInProgress = false;
  let nbActiveProduct = null;   // 'gummies' | 'powder' while upgrading
  let nbPendingUpgrade = null;  // { variantId, sellingPlanId } while upgrading
  let nbLastCart = null;        // last /cart.js result, reused on click to skip a request
  let nbT0 = 0;

  function nbTime(label) {
    const now = performance.now();
    const line = '[NB Upgrade Widget] ⏱ ' + label + ': ' + Math.round(now - nbT0) + 'ms since click';
    (window.__NB_UPGRADE_TIMES__ = window.__NB_UPGRADE_TIMES__ || []).push(line);
    console.warn(line); // warn, because this site suppresses console.log
  }

  /* ---------- Widget lines (one per eligible cart item) ---------- */

  function getLines() {
    return Array.from(document.querySelectorAll(NB_LINE_SELECTOR));
  }

  function getLineProduct(line) {
    return (line && line.getAttribute('data-nb-upgrade-product')) || 'gummies';
  }

  function getLineKey(line) {
    return (line && line.getAttribute('data-nb-item-key')) || null;
  }

  function hideLine(line) {
    if (line) line.style.display = 'none';
  }

  function showLine(line) {
    if (line) line.style.display = '';
  }

  function showActiveProductLines() {
    getLines().forEach(function (line) {
      if (getLineProduct(line) === nbActiveProduct) showLine(line);
    });
  }

  function setCartUpdatingState(isUpdating) {
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer) return;

    if (isUpdating) {
      cartDrawer.setAttribute('data-nb-upgrading', 'true');
    } else {
      cartDrawer.removeAttribute('data-nb-upgrading');
    }
  }

  function injectUpgradeStyles() {
    if (document.querySelector('#nb-upgrade-processing-style')) return;

    const style = document.createElement('style');
    style.id = 'nb-upgrade-processing-style';
    style.textContent = `
      [data-cart-drawer][data-nb-upgrading="true"] .single-cart-item {
        opacity: 0.55;
        pointer-events: none;
      }
    `;

    document.head.appendChild(style);
  }

  /* ---------- Cart data ---------- */

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch /cart.js');
    }

    nbLastCart = await response.json();
    return nbLastCart;
  }

  function getSellingPlanId(item) {
    if (!item || !item.selling_plan_allocation) return null;

    if (
      item.selling_plan_allocation.selling_plan &&
      item.selling_plan_allocation.selling_plan.id
    ) {
      return Number(item.selling_plan_allocation.selling_plan.id);
    }

    if (item.selling_plan_allocation.selling_plan_id) {
      return Number(item.selling_plan_allocation.selling_plan_id);
    }

    return null;
  }

  function normalizeSku(sku) {
    return String(sku || '').trim().toLowerCase();
  }

  function isEligibleQty(quantity) {
    return Number(quantity) >= NB_MIN_QTY;
  }

  /* Returns the rule that matches this cart item, or null. SKU-specific rules win over "any SKU" rules. */
  function getRuleForItem(item) {
    const sellingPlanId = getSellingPlanId(item);
    if (!sellingPlanId) return null;

    const sku = normalizeSku(item.sku);
    const planRules = NB_UPGRADE_RULES.filter(function (rule) {
      return Number(rule.fromSellingPlanId) === sellingPlanId;
    });

    return (
      planRules.find(function (rule) { return rule.fromSku && normalizeSku(rule.fromSku) === sku; }) ||
      planRules.find(function (rule) { return !rule.fromSku; }) ||
      null
    );
  }

  /* Is this cart item an upgrade (3-pack) item? Optionally limited to one product. */
  function isUpgradeItem(item, product) {
    return NB_UPGRADE_RULES.some(function (rule) {
      return (
        (!product || rule.product === product) &&
        Number(item.variant_id) === Number(rule.toVariantId) &&
        getSellingPlanId(item) === Number(rule.toSellingPlanId)
      );
    });
  }

  function itemMatchesProduct(item, product) {
    const rule = getRuleForItem(item);
    return !!(rule && rule.product === product && isEligibleQty(item.quantity) && !isUpgradeItem(item));
  }

  /* Find the eligible original item for a widget: by its cart key first, then any item of that product. */
  function findEligibleItem(cart, product, key) {
    if (key) {
      const byKey = cart.items.find(function (item) {
        return item.key === key && itemMatchesProduct(item, product);
      });
      if (byKey) return byKey;
    }

    return cart.items.find(function (item) {
      return itemMatchesProduct(item, product);
    }) || null;
  }

  function cartHasUpgradeFor(cart, product) {
    return cart.items.some(function (item) {
      return isUpgradeItem(item, product);
    });
  }

  function upgradedItemIsVisibleInDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !nbPendingUpgrade) return false;

    return drawer.innerHTML.includes(String(nbPendingUpgrade.variantId));
  }

  /* ---------- Buttons ---------- */

  function setButtonsLoading(line, isLoading) {
    const scope = line || document;

    scope.querySelectorAll('.nb-upgrade-button').forEach(function (button) {
      if (isLoading) {
        button.dataset.originalText = button.textContent.trim();
        button.textContent = 'Upgrading your cart...';
        button.disabled = true;
        button.style.opacity = '0.6';
        button.style.cursor = 'progress';
      } else {
        button.textContent = button.dataset.originalText || 'Upgrade & Save Today';
        button.disabled = false;
        button.style.opacity = '';
        button.style.cursor = '';
      }
    });
  }

  /* ---------- Cart changes ---------- */

  async function addUpgradeItem(rule, quantity) {
    const itemToAdd = {
      id: Number(rule.toVariantId),
      quantity: Number(quantity),
      selling_plan: Number(rule.toSellingPlanId)
    };

    console.log('[NB Upgrade Widget] Adding upgrade item:', itemToAdd);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [itemToAdd] })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('[NB Upgrade Widget] Add error:', errorText);
      throw new Error('Unable to add upgrade product: ' + errorText);
    }

    return await response.json();
  }

  async function removeOriginalItems(product) {
    /*
      Re-fetch the cart after adding the upgrade item (avoids stale item keys),
      then remove every item of THIS product that matches an upgrade rule.
      Upgrade items and the other product's items are never removed.
    */
    const freshCart = await getCart();
    nbTime('fresh cart.js done');

    const updates = {};

    freshCart.items.forEach(function (item) {
      const rule = getRuleForItem(item);
      if (rule && rule.product === product && !isUpgradeItem(item)) {
        updates[item.key] = 0;
      }
    });

    console.log('[NB Upgrade Widget] Removing original ' + product + ' items:', updates);

    if (!Object.keys(updates).length) {
      console.log('[NB Upgrade Widget] No original items left to remove.');
      return freshCart;
    }

    /* Ask Shopify to return the re-rendered cart sections in this same request (saves a round trip). */
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: updates,
        sections: NB_CART_SECTIONS,
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('[NB Upgrade Widget] Remove error:', errorText);
      throw new Error('Unable to remove original subscription item: ' + errorText);
    }

    return await response.json();
  }

  function dispatchCartSections(sections) {
    document.dispatchEvent(
      new CustomEvent('shapes:cart:update', {
        bubbles: true,
        detail: { response: { sections: { ...sections } } }
      })
    );
  }

  async function refreshCartDrawer(updateResponse) {
    if (updateResponse && updateResponse.sections && updateResponse.sections['cart-items']) {
      dispatchCartSections(updateResponse.sections);
      return;
    }

    const response = await fetch(`${window.location.pathname}?sections=${NB_CART_SECTIONS}`);
    const data = await response.json();

    if (!data.status) {
      dispatchCartSections(data);
    }
  }

  function waitUntilUpgradeVisible(callback, attempts) {
    const maxAttempts = attempts || 30; // 30 × 50ms = 1.5s max
    let count = 0;

    const interval = setInterval(function () {
      count += 1;

      if (upgradedItemIsVisibleInDrawer()) {
        clearInterval(interval);
        callback(true);
        return;
      }

      if (count >= maxAttempts) {
        clearInterval(interval);
        callback(false);
      }
    }, 50);
  }

  /* ---------- Show / hide each widget ---------- */

  async function evaluateUpgradeWidgets() {
    try {
      if (nbUpgradeInProgress) {
        showActiveProductLines();
        return;
      }

      const lines = getLines();
      if (!lines.length) return;

      const cart = await getCart();

      console.log(
        '[NB Upgrade Widget] Cart items:',
        cart.items.map(function (item) {
          return {
            title: item.product_title,
            sku: item.sku,
            variant_id: item.variant_id,
            quantity: item.quantity,
            selling_plan_id: getSellingPlanId(item),
            matched_rule: getRuleForItem(item),
            key: item.key
          };
        })
      );

      lines.forEach(function (line) {
        const product = getLineProduct(line);
        const eligibleItem = findEligibleItem(cart, product, getLineKey(line));
        const alreadyUpgraded = cartHasUpgradeFor(cart, product);

        if (eligibleItem && !alreadyUpgraded) {
          showLine(line);
        } else {
          hideLine(line);
        }
      });
    } catch (error) {
      console.error('[NB Upgrade Widget] Visibility error:', error);
      getLines().forEach(hideLine);
    }
  }

  /* ---------- Upgrade click ---------- */

  function finishUpgrade(line) {
    nbUpgradeInProgress = false;
    nbActiveProduct = null;
    nbPendingUpgrade = null;
    setCartUpdatingState(false);
    setButtonsLoading(line, false);
  }

  async function handleUpgradeClick(line) {
    if (nbUpgradeInProgress) return;

    const product = getLineProduct(line);
    const key = getLineKey(line);

    console.log('[NB Upgrade Widget] Upgrade button clicked for:', product);
    nbT0 = performance.now();
    window.__NB_UPGRADE_TIMES__ = [];

    try {
      nbUpgradeInProgress = true;
      nbActiveProduct = product;
      setCartUpdatingState(true);
      showLine(line);
      setButtonsLoading(line, true);

      /* Reuse the cart fetched when the widget was shown; only re-fetch if needed. */
      let cart = nbLastCart || await getCart();
      if (!findEligibleItem(cart, product, key)) cart = await getCart();

      const eligibleItem = findEligibleItem(cart, product, key);

      if (cartHasUpgradeFor(cart, product)) {
        finishUpgrade(line);
        hideLine(line);
        return;
      }

      if (!eligibleItem) {
        finishUpgrade(line);

        alert(
          'No eligible subscription item found. The cart item may not match an upgrade rule (selling plan + SKU).'
        );

        await evaluateUpgradeWidgets();
        return;
      }

      const rule = getRuleForItem(eligibleItem);
      const upgradeQty = Number(eligibleItem.quantity) * Number(rule.qtyMultiplier || 1);
      nbPendingUpgrade = { variantId: rule.toVariantId, sellingPlanId: rule.toSellingPlanId };

      console.log('[NB Upgrade Widget] Matched rule:', rule, 'Upgrade qty:', upgradeQty);

      nbTime('cart ready');
      await addUpgradeItem(rule, upgradeQty);
      nbTime('add.js done');

      /* Remove the original item(s) of this product after the upgrade variant has been added. */
      const updateResponse = await removeOriginalItems(product);
      nbTime('remove (update.js) done');

      await refreshCartDrawer(updateResponse);
      nbTime('drawer refresh dispatched' + (updateResponse && updateResponse.sections ? ' (sections from update.js)' : ' (extra fetch)'));

      waitUntilUpgradeVisible(function (seen) {
        nbTime(seen ? 'upgrade visible in drawer' : 'gave up waiting (upgrade not detected in drawer)');
        finishUpgrade(line);
        evaluateUpgradeWidgets();

        console.log('[NB Upgrade Widget] Upgrade complete.');
      });
    } catch (error) {
      finishUpgrade(line);

      console.error('[NB Upgrade Widget] Upgrade error:', error);
      alert('Upgrade failed: ' + error.message);

      setTimeout(evaluateUpgradeWidgets, 300);
    }
  }

  /* ---------- Listeners ---------- */

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.nb-upgrade-button');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const line = button.closest(NB_LINE_SELECTOR);
      handleUpgradeClick(line);
    },
    true
  );

  document.addEventListener('shapes:cart:update', function () {
    if (nbUpgradeInProgress) {
      showActiveProductLines();
      return;
    }

    setTimeout(evaluateUpgradeWidgets, 300);
  });

  const observer = new MutationObserver(function () {
    if (!document.querySelector(NB_LINE_SELECTOR)) return;

    if (nbUpgradeInProgress) {
      showActiveProductLines();
      return;
    }

    clearTimeout(window.__NB_UPGRADE_WIDGET_EVALUATE_TIMER__);
    window.__NB_UPGRADE_WIDGET_EVALUATE_TIMER__ = setTimeout(evaluateUpgradeWidgets, 150);
  });

  injectUpgradeStyles();

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(evaluateUpgradeWidgets, 500);
})();